import "./SchoolsListing.css";
import React, { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SchoolsListingViewModel from "./SchoolsListingViewModel";
import ActionConfirmation from "../../../../Components/ActionConfirmation/ActionConfirmation";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";
import Loader from "../../../../Components/Loader/Loader";

const SchoolsListing = () => {
  const navigate = useNavigate();
  const [
    SchoolsArray,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    loader,
  ] = SchoolsListingViewModel();
  const SchoolAddedResp = IsSchoolAdded();

  const [RegistrationNoFilter, setRegistrationNoFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [addressFilter, setAddressFilter] = useState("");

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper school-listing">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Schools</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="index.html">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Schools</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by registration no ..."
                    onChange={(e) => {
                      setRegistrationNoFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name ..."
                    onChange={(e) => {
                      setNameFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by address ..."
                    onChange={(e) => {
                      setAddressFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Schools</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <button
                          type="button"
                          disabled={SchoolAddedResp}
                          //   to="/user/admin/schools/add"
                          onClick={() => {
                            navigate("/user/admin/schools/add");
                          }}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  <div className="table-responsive">
                    {loader ? (
                      <Loader />
                    ) : (
                      <>
                        <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                          <thead className="student-thread">
                            <tr>
                              <th>Reg No</th>
                              <th>Name</th>
                              <th>HOD</th>
                              <th>Started Year</th>
                              <th>School Address</th>
                              <th className="text-end">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {SchoolsArray &&
                              SchoolsArray.filter(
                                (school) =>
                                  addressFilter === "" ||
                                  school.SchoolAddress.toLowerCase().includes(
                                    addressFilter.toLowerCase()
                                  )
                              )
                                .filter(
                                  (school) =>
                                    nameFilter === "" ||
                                    school.SchoolName.toLowerCase().includes(
                                      nameFilter.toLowerCase()
                                    )
                                )
                                .filter(
                                  (school) =>
                                    RegistrationNoFilter === "" ||
                                    school.SchoolRegistrationNo.toLowerCase().includes(
                                      RegistrationNoFilter.toLowerCase()
                                    )
                                )
                                .map((school, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{school.SchoolRegistrationNo}</td>
                                      <td className="text-capitalize">
                                        {school.SchoolName}
                                      </td>
                                      <td>{school.HeadOfSchool}</td>
                                      <td>{school.SchoolStartDate}</td>
                                      <td>{school.SchoolAddress}</td>
                                      <td className="text-end">
                                        <div className="actions">
                                          <a
                                            onClick={() => {
                                              handleOpenDeleteDialog(school.id);
                                            }}
                                            href="#"
                                            className="btn btn-sm bg-success-light me-2"
                                          >
                                            <i className="fa-regular fa-trash-can"></i>
                                          </a>
                                          <Link
                                            to={`/user/admin/schools/update/${school.id}`}
                                            className="btn btn-sm bg-danger-light"
                                          >
                                            <i className="fa-regular fa-pen-to-square"></i>
                                          </Link>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                          </tbody>
                        </table>
                        {SchoolsArray?.length <= 0 && <NoDataFound />}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this school?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </Fragment>
  );
};

export default SchoolsListing;
